import { IonIcon } from '@ionic/react'
import { checkmarkCircleOutline } from 'ionicons/icons'
import React, { FC } from 'react'

interface ProgressCircleProps {
	step?: number
	steps?: number
	isMultiStep: boolean
	isCompleted: boolean
}

const ProgressCircle: FC<ProgressCircleProps> = ({ step, steps, isMultiStep, isCompleted }) => {
	const bgColor = isCompleted
		? 'bg-[#cae3cc] dark:bg-brand-secondary-100-dark'
		: 'bg-[#e5e5e5] dark:bg-text-grey-100'

	return (
		<div className={`w-12 h-12 rounded-full flex items-center justify-center ${bgColor}`}>
			{isCompleted ? (
				<IonIcon
					icon={checkmarkCircleOutline}
					className='text-2xl !text-[2.2rem] text-brand-secondary-100-light dark:text-brand-primary-200-dark [--ionicon-stroke-width:42px]'
				/>
			) : isMultiStep ? (
				<span className={`text-sm font-bold text-text-dark`}>
					{step}/{steps}
				</span>
			) : null}
		</div>
	)
}

export default ProgressCircle
